import "./RevertQuoteButton.scss";
import { useT } from "i18n";

export default function RevertQuoteButton({ onClick }: { onClick: () => void }) {
  const t = useT();
  return (
    <button className={"pull-back-button"} onClick={() => onClick()}>
      <i className={"info circle icon"} />
      {t("component.revertQuoteButton.revertQuote", "Revert Quote")}
    </button>
  );
}
